import { createActions } from 'reduxsauce';

var _createActions = createActions({
  sortByChange: function sortByChange(json) {
    return {
      type: 'RETAIL_SORT_BY_CHANGE',
      sortBy: json.sortBy,
      sortOrder: json.sortOrder
    };
  },
  pageChange: function pageChange(json) {
    return {
      type: 'RETAIL_PAGE_CHANGE',
      currentPage: json.currentPage
    };
  },
  searchField: function searchField(json) {
    return {
      type: 'RETAIL_TERM_CHANGE',
      searchTerm: json.searchTerm
    };
  },
  pageSizeChange: function pageSizeChange(json) {
    return {
      type: 'RETAIL_PAGE_SIZE_CHANGE',
      pageSize: json.pageSize
    };
  },
  facetsChange: function facetsChange(json) {
    return {
      type: 'RETAIL_FACETS_CHANGE',
      selectedFacets: json.selectedFacets,
      currentPage: 0
    };
  },
  categoriesChange: function categoriesChange(json) {
    return {
      type: 'RETAIL_CATEGORIES_CHANGE',
      categories: json.categories,
      currentPage: 0
    };
  },
  dataSourceChange: function dataSourceChange(json) {
    return {
      type: 'RETAIL_DATA_SOURCE_CHANGE',
      dataSource: json.dataSource
    };
  },
  sortChange: function sortChange(json) {
    return {
      type: 'RETAIL_SORT_CHANGE',
      order: json.order,
      sortBy: json.sortBy,
      currentPage: 0
    };
  },
  termChange: function termChange() {
    return {
      type: 'RETAIL_TERM_CHANGE'
    };
  },
  request: function request() {
    return {
      type: 'RETAIL_REQUEST'
    };
  },
  response: function response(json) {
    return {
      type: 'RETAIL_RESPONSE',
      products: json.Products,
      totalRetail: json.TotalItemCount,
      totalPageCount: json.TotalPageCount,
      currentPage: parseInt(json.CurrentPageNumber),
      sortByOptions: json.SortOptions,
      pageCount: json.MaxPageSize,
      pageSize: json.MaxPageSize,
      cards: json.Cards,
      facets: json.Facets
    };
  },
  requestCategories: function requestCategories() {
    return {
      type: 'RETAIL_REQUEST_CATEGORIES'
    };
  },
  receiveCategories: function receiveCategories(json) {
    return {
      type: 'RETAIL_RECEIVE_CATEGORIES',
      retailCategories: json.retailCategories
    };
  },
  addToRecentlyViewed: function addToRecentlyViewed(json) {
    return {
      type: 'RETAIL_ADD_TO_RECENTLY_VIEWED',
      recentlyViewed: json
    };
  },
  setCurrentCategory: function setCurrentCategory(json) {
    return {
      type: 'RETAIL_SET_CURRENT_CATEGORY',
      currentCategory: json
    };
  }
}, {
  prefix: 'RETAIL_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};